import React from 'react'
import { withSiteData, Link } from 'react-static'
import Title from '../../components/Title'
import Transitionable from '../Transitionable'
import styles from './styles.module.css'

class Home extends Transitionable {
  robotState = 'home'

  renderTransitioned() {
    return <section className={styles.home}>
             <Title />
             <h1><Link to="/blog">>> massiverobot.co.uk<span className={styles.cursor}>_</span></Link></h1>
           </section>
  }
}

export default Home


// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Home/index.js